import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/layout/borsdorf-logo-weiss.svg")